import React from "react"
import GlobalStyles from "@mui/material/GlobalStyles"
import {PLATFORM_MODERNISATION_HEADER_ID} from "./config/constants"

// #skip-namespace is here in purpose
// This is here to give the ability to skip adding a namespace to a css selector
// see: https://dev.azure.com/Next-Technology/Ecom.UI/_wiki/wikis/Ecom.UI.wiki/14527/EPM-MVC-CSS-Overriding-Issues

export const globalStyle = (
    <GlobalStyles
        styles={`
            #skip-namespace body {
                margin: 0;
                overflow-y: scroll;
                text-rendering: optimizeLegibility;
                -webkit-font-smoothing: antialiased;
            }

            #skip-namespace [dir="rtl"] .ContentArea{
                /* Override MVC */
                min-width: 100%;
            }

            #skip-namespace ${PLATFORM_MODERNISATION_HEADER_ID} {
                position: fixed;
                top: 0;
                width: 100%;
                z-index: 9999;
                left: 0;
                margin-top: var(--next-header-branchio-height, 0px);

                font-size: 16px;
                & * {
                    box-sizing: border-box;
                }

                ul,
                ul li {
                    list-style: none;
                }

                img,
                a img {
                    display: inline;
                }

                & button:focus,
                a:focus {
                    outline: none;
                }

                & *[data-focus-visible-added]:focus {
                    outline: 2px solid #1d89dd;
                }
                & #header-big-screen-search-box:focus,
                #header-small-screen-search-box:focus {
                    outline: none;
                }
            }
        `}
    />
)
